(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__oriorHeroMotionInitialized) {
      return;
    }

    window.__oriorHeroMotionInitialized = true;

    const heroSelector = 'main > .shopify-section:first-child > [id^="Hero-"].hero';
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const parallaxSpeed = 0.55;
    const maxOffset = 220;
    let frame = null;

    const getHeroes = () => Array.from(document.querySelectorAll(heroSelector));

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const resetHeroes = () => {
      getHeroes().forEach((hero) => {
        hero.removeAttribute('data-parallax-ready');
        hero.style.removeProperty('--hero-parallax-y');
      });
    };

    const updateHeroes = () => {
      frame = null;

      if (reducedMotionQuery.matches) {
        resetHeroes();
        return;
      }

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      getHeroes().forEach((hero) => {
        const rect = hero.getBoundingClientRect();

        if (rect.bottom <= 0 || rect.top >= viewportHeight) {
          return;
        }

        const sectionMaxOffset = Math.min(maxOffset, rect.height * 0.16);
        const offset = clamp(Math.max(-rect.top, 0) * parallaxSpeed, 0, sectionMaxOffset);
        hero.setAttribute('data-parallax-ready', 'true');
        hero.style.setProperty('--hero-parallax-y', `${offset}px`);
      });
    };

    const scheduleUpdate = () => {
      if (frame !== null) {
        return;
      }

      frame = window.requestAnimationFrame(updateHeroes);
    };

    const handleMotionPreferenceChange = () => {
      if (reducedMotionQuery.matches) {
        resetHeroes();
      } else {
        scheduleUpdate();
      }
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);

    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', handleMotionPreferenceChange);
    } else if (typeof reducedMotionQuery.addListener === 'function') {
      reducedMotionQuery.addListener(handleMotionPreferenceChange);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
    } else {
      scheduleUpdate();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
